export default "__VITE_ASSET__CVLUMl8G__"